import React from "react";
import { PortfolioData } from "../types/portfolio";

interface ContactProps {
  data: PortfolioData;
}

const Contact: React.FC<ContactProps> = ({ data }) => {
  return (
    <section className="bg-gradient-to-b from-navy via-deep-blue to-navy text-white py-24">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-manrope font-bold mb-4">
            {data.contact.heading}
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-8">
            {data.contact.description}
          </p>
          <div className="h-1 w-16 bg-gold mx-auto rounded-full"></div>
        </div>

        {/* Contact Information Grid */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-3">
          <a
            href={`https://mail.google.com/mail/?view=cm&fs=1&to=${data.personal.email}`}
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-white/10 hover:bg-gold border-2 border-white/20 hover:border-gold text-white hover:text-navy rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
            </svg>
            Send Email
          </a>
        </div>

        {/* Social Links */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          {data.social.linkedin && (
            <a
              href={data.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group px-8 py-4 bg-white/10 hover:bg-gold border-2 border-white/20 hover:border-gold text-white hover:text-navy rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
              </svg>
              Connect on LinkedIn
            </a>
          )}

          {/* Location */}
          <div className="px-8 py-4 bg-white/10 border-2 border-white/20 rounded-xl font-semibold flex items-center justify-center gap-2 text-gray-300">
            <svg
              className="w-5 h-5 text-gold"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
              ></path>
            </svg>
            {data.personal.location}
          </div>
        </div>

        {/* Bottom CTA */}
        {/* <div className="text-center pt-12 border-t border-white/10">
          <p className="text-gray-300 mb-6">
            Let's discuss how I can contribute to your business analysis,
            reporting, and process improvement initiatives.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${data.personal.email}`}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white/10 hover:bg-gold border-2 border-white/20 hover:border-gold text-white hover:text-navy rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
              Send Email
            </a>

            {data.social.linkedin && (
              <a
                href={data.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white/10 hover:bg-gold border-2 border-white/20 hover:border-gold text-white hover:text-navy rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                </svg>
                View LinkedIn Profile
              </a>
            )}
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Contact;
